export default __webpack_public_path__ + "static/media/step1.13bd12fc.svg";